import React from 'react'
interface InputProps extends React.HTMLProps<HTMLDivElement> {
    className?: string
}
const paddingRegex = /(\b|\s)(p|px|py)-\d+/
const Card = ({className, ...props}: InputProps) => {
    let cardClass = 'rounded-xl bg-grey-10 px-12 py-7.5'
    if (className) {
        cardClass = `
            rounded-xl bg-white
            ${className}
            ${
                className.match(paddingRegex) ? '' : 'px-12 py-7.5' //overrides default paddings
            } 
        `
    }
    return <div className={cardClass} {...props} />
}

export default Card
